var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g3, _g4, _g5, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThumbUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 88,
    viewBox: "0 0 124 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.2979 60.0202C97.2979 47.1378 97.2979 34.2434 97.2979 21.355C97.2979 20.162 96.3278 19.1979 95.1348 19.1979C73.7204 19.1979 52.306 19.1979 30.8917 19.1979C30.3855 19.1979 29.9878 19.3305 29.5841 19.6317L27.8066 20.9814C27.7946 20.9875 27.7886 20.9935 27.7765 20.9995L27.7102 21.0537C27.192 21.4454 26.8546 22.072 26.8546 22.771C26.8546 35.6654 26.8546 48.5538 26.8546 61.4422C26.8546 62.6352 27.8247 63.6053 29.0117 63.6053C50.4321 63.6053 71.8465 63.6053 93.2609 63.6053C93.7489 63.6053 94.2008 63.4426 94.5624 63.1655L96.4423 61.7495C96.9786 61.3398 97.2979 60.7011 97.2979 60.0202Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.9847 27.5128C71.9847 27.8562 71.9124 28.1876 71.7799 28.4829C71.6714 28.501 71.5569 28.507 71.4424 28.507C65.8207 28.507 60.199 28.507 54.5833 28.507C52.8359 28.507 51.667 26.7174 52.372 25.1207C52.4804 25.1026 52.5949 25.0966 52.7094 25.0966C58.3251 25.0966 63.9468 25.0966 69.5685 25.0966C70.9062 25.0966 71.9847 26.1751 71.9847 27.5128Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M97.298 21.355C97.298 34.2434 97.298 47.1318 97.298 60.0202C97.298 60.7011 96.9847 61.3337 96.4424 61.7435L94.5685 63.1655C95.0867 62.7738 95.4241 62.1472 95.4241 61.4422C95.4241 48.5538 95.4241 35.6654 95.4241 22.771C95.4241 21.578 94.454 20.6079 93.261 20.6079C71.8466 20.6079 50.4262 20.6079 29.0118 20.6079C28.566 20.6079 28.1502 20.7464 27.8068 20.9754L29.5903 19.6257C29.994 19.3244 30.3856 19.1859 30.8918 19.1859C52.3062 19.1859 73.7266 19.1859 95.1409 19.1859C96.3279 19.1919 97.298 20.162 97.298 21.355Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M95.424 22.7713C95.424 35.6596 95.424 48.5541 95.424 61.4425C95.424 62.1474 95.0866 62.7741 94.5684 63.1657C94.2069 63.4369 93.755 63.6056 93.2669 63.6056C71.8525 63.6056 50.4321 63.6056 29.0177 63.6056C27.8247 63.6056 26.8546 62.6415 26.8546 61.4425C26.8546 48.5541 26.8546 35.6657 26.8546 22.7713C26.8546 22.0663 27.192 21.4457 27.7102 21.048L27.7765 20.9938C27.7825 20.9877 27.7946 20.9817 27.8066 20.9757C28.1501 20.7407 28.5719 20.6081 29.0117 20.6081C50.4261 20.6081 71.8465 20.6081 93.2609 20.6081C94.4539 20.6141 95.424 21.5782 95.424 22.7713ZM86.9342 47.831C86.9342 47.12 86.9342 46.403 86.9342 45.692C86.9342 45.3907 86.6931 45.1497 86.3919 45.1497C77.3839 45.1497 68.3758 45.1497 59.3678 45.1497C59.0666 45.1497 58.8255 45.3907 58.8255 45.692C58.8255 46.403 58.8255 47.12 58.8255 47.831C58.8255 48.1323 59.0666 48.3733 59.3678 48.3733C68.3758 48.3733 77.3839 48.3733 86.3919 48.3733C86.6931 48.3733 86.9342 48.1323 86.9342 47.831ZM86.9342 40.474C86.9342 39.763 86.9342 39.0459 86.9342 38.3349C86.9342 38.0397 86.6931 37.7987 86.3919 37.7987C77.3839 37.7987 68.3758 37.7987 59.3678 37.7987C59.0666 37.7987 58.8255 38.0397 58.8255 38.3349C58.8255 39.0459 58.8255 39.763 58.8255 40.474C58.8255 40.7752 59.0666 41.0163 59.3678 41.0163C68.3758 41.0163 77.3839 41.0163 86.3919 41.0163C86.6931 41.0163 86.9342 40.7752 86.9342 40.474ZM73.4252 55.1941C73.4252 54.4831 73.4252 53.7661 73.4252 53.0551C73.4252 52.7538 73.1841 52.5128 72.8829 52.5128H59.3739C59.0726 52.5128 58.8316 52.7538 58.8316 53.0551V55.1941C58.8316 55.4954 59.0726 55.7364 59.3739 55.7364H72.8829C73.1781 55.7304 73.4252 55.4893 73.4252 55.1941ZM71.7802 28.4834C71.9128 28.1881 71.9851 27.8567 71.9851 27.5133C71.9851 26.1817 70.9065 25.0971 69.5689 25.0971C63.9472 25.0971 58.3315 25.0971 52.7097 25.0971C52.5952 25.0971 52.4868 25.1031 52.3723 25.1212C51.1973 25.2839 50.2935 26.2961 50.2935 27.5133C50.2935 28.8509 51.3721 29.9295 52.7097 29.9295C58.3315 29.9295 63.9472 29.9295 69.5689 29.9295C70.557 29.9234 71.4066 29.333 71.7802 28.4834ZM55.4392 55.7304V37.7927C55.4392 37.1961 54.9572 36.7141 54.3607 36.7141C48.3835 36.7141 42.4062 36.7141 36.423 36.7141C35.8265 36.7141 35.3444 37.1961 35.3444 37.7927C35.3444 43.7699 35.3444 49.7471 35.3444 55.7304C35.3444 56.3269 35.8265 56.8089 36.423 56.8089C36.7363 56.8089 37.0436 56.8089 37.3569 56.8089C42.7135 56.8089 48.0701 56.8089 53.4268 56.8089C53.7341 56.8089 54.0474 56.8089 54.3607 56.8089C54.9572 56.8149 55.4392 56.3269 55.4392 55.7304Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9343 45.6923C86.9343 46.4033 86.9343 47.1203 86.9343 47.8313C86.9343 48.1326 86.6933 48.3736 86.392 48.3736C77.384 48.3736 68.376 48.3736 59.368 48.3736C59.0667 48.3736 58.8257 48.1326 58.8257 47.8313C58.8257 47.1203 58.8257 46.4033 58.8257 45.6923C58.8257 45.391 59.0667 45.15 59.368 45.15C68.376 45.15 77.384 45.15 86.392 45.15C86.6933 45.15 86.9343 45.391 86.9343 45.6923Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9343 38.3351C86.9343 39.0461 86.9343 39.7631 86.9343 40.4741C86.9343 40.7754 86.6933 41.0164 86.392 41.0164C77.384 41.0164 68.376 41.0164 59.368 41.0164C59.0667 41.0164 58.8257 40.7754 58.8257 40.4741C58.8257 39.7631 58.8257 39.0461 58.8257 38.3351C58.8257 38.0398 59.0667 37.7988 59.368 37.7988C68.376 37.7988 77.384 37.7988 86.392 37.7988C86.6933 37.7988 86.9343 38.0398 86.9343 38.3351Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4253 53.0488C73.4253 53.7598 73.4253 54.4768 73.4253 55.1878C73.4253 55.4891 73.1842 55.7301 72.883 55.7301H59.374C59.0727 55.7301 58.8317 55.4891 58.8317 55.1878V53.0488C58.8317 52.7475 59.0727 52.5065 59.374 52.5065H72.883C73.1782 52.5126 73.4253 52.7536 73.4253 53.0488Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M71.4426 28.507C71.551 28.507 71.6655 28.501 71.78 28.4829C71.4064 29.3325 70.5568 29.929 69.5687 29.929C63.947 29.929 58.3313 29.929 52.7095 29.929C51.3719 29.929 50.2933 28.8505 50.2933 27.5128C50.2933 26.2957 51.1971 25.2834 52.3721 25.1207C51.6671 26.7175 52.8361 28.507 54.5834 28.507C60.1991 28.507 65.8209 28.507 71.4426 28.507Z",
    fill: "url(#paint2_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4394 37.7986V55.7363C55.4394 56.3329 54.9574 56.8149 54.3609 56.8149C54.0536 56.8149 53.7402 56.8149 53.4269 56.8149C52.74 52.9164 49.3477 50.0724 45.389 50.0724C41.4303 50.0724 38.044 52.9104 37.3571 56.8149C37.0438 56.8149 36.7365 56.8149 36.4232 56.8149C35.8266 56.8149 35.3446 56.3268 35.3446 55.7363C35.3446 49.7591 35.3446 43.7759 35.3446 37.7986C35.3446 37.2021 35.8266 36.7201 36.4232 36.7201C42.4004 36.7201 48.3836 36.7201 54.3609 36.7201C54.9574 36.7141 55.4394 37.1961 55.4394 37.7986ZM48.6608 46.7404C49.6731 44.9327 49.0344 42.6491 47.2328 41.6308C45.4251 40.6185 43.1415 41.2572 42.1232 43.0588C41.1049 44.8604 41.7496 47.1501 43.5512 48.1684C45.3589 49.1867 47.6425 48.542 48.6608 46.7404Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M53.427 56.8143C48.0704 56.8143 42.7138 56.8143 37.3572 56.8143C38.0441 52.9159 41.4364 50.0719 45.3891 50.0719C49.3478 50.0719 52.7341 52.9098 53.427 56.8143Z",
    fill: "url(#paint3_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M47.2266 41.6306C49.0342 42.6429 49.6729 44.9325 48.6546 46.7402C47.6363 48.5478 45.3527 49.1865 43.545 48.1682C41.7374 47.1499 41.0987 44.8663 42.117 43.0586C43.1353 41.251 45.425 40.6183 47.2266 41.6306Z",
    fill: "url(#paint4_linear)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M108.538 63.7625H107.082V72.0002H108.538V63.7625Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M111.929 67.1534H103.692V68.6091H111.929V67.1534Z",
    fill: "url(#paint6_linear)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter3_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7458 39.3223C11.9745 39.6236 11.1008 39.3042 10.7152 38.5752C10.6851 38.5209 10.655 38.4667 10.6128 38.4245C10.3115 38.0871 9.79935 38.057 9.46193 38.3522C9.25706 38.533 9.15463 38.8041 9.19681 39.0753C9.20283 39.1355 9.22091 39.1958 9.24501 39.25C9.54628 40.0213 9.22694 40.895 8.49786 41.2806C8.44363 41.3107 8.3894 41.3408 8.34722 41.383C8.0098 41.6843 7.97967 42.1964 8.27492 42.5339C8.45568 42.7387 8.72683 42.8412 8.99797 42.799C9.05822 42.793 9.11848 42.7749 9.17271 42.7508C9.94396 42.4495 10.8177 42.7689 11.2033 43.4979C11.2334 43.5522 11.2635 43.6064 11.3057 43.6486C11.607 43.986 12.1191 44.0161 12.4566 43.7209C12.6614 43.5401 12.7639 43.269 12.7217 42.9978C12.7157 42.9376 12.6976 42.8773 12.6735 42.8231C12.3722 42.0518 12.6916 41.1781 13.4206 40.7925C13.4749 40.7624 13.5291 40.7323 13.5713 40.6901C13.9087 40.3888 13.9388 39.8767 13.6436 39.5392C13.4628 39.3344 13.1917 39.2319 12.9205 39.2741C12.8663 39.2801 12.806 39.2982 12.7458 39.3223Z",
    fill: "url(#paint7_linear)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter4_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.1398 10.3661C77.8978 10.3661 79.3229 8.94101 79.3229 7.18306C79.3229 5.4251 77.8978 4 76.1398 4C74.3819 4 72.9568 5.4251 72.9568 7.18306C72.9568 8.94101 74.3819 10.3661 76.1398 10.3661Z",
    fill: "#D0D4DF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 18.8546,
    y: 15.1979,
    width: 90.4433,
    height: 64.4074,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i",
    x: 51.1635,
    y: 23.0966,
    width: 20.8213,
    height: 5.4104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 95.6915,
    y: 59.7625,
    width: 28.2377,
    height: 28.2377,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d",
    x: 0.0722656,
    y: 34.1496,
    width: 25.774,
    height: 25.774,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d",
    x: 64.9568,
    y: 0,
    width: 26.3661,
    height: 26.3661,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 27.8056,
    y1: 41.1792,
    x2: 97.2954,
    y2: 41.1792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 26.8527,
    y1: 42.1064,
    x2: 95.4224,
    y2: 42.1064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 50.2909,
    y1: 27.5205,
    x2: 71.7803,
    y2: 27.5205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 37.3548,
    y1: 53.4422,
    x2: 53.4264,
    y2: 53.4422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 41.6389,
    y1: 44.9006,
    x2: 49.1418,
    y2: 44.9006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 107.08,
    y1: 67.8826,
    x2: 108.532,
    y2: 67.8826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 103.688,
    y1: 67.8807,
    x2: 111.928,
    y2: 67.8807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 8.86857,
    y1: 43.1316,
    x2: 13.0595,
    y2: 38.9407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUsers);
export default __webpack_public_path__ + "static/media/thumb_users.278653761784f977d1252317c9b48918.svg";
export { ForwardRef as ReactComponent };